import lazyLoadAdsInstance from './front/LazyLoadAds'

lazyLoadAdsInstance && console.log('LazyLoadAds loaded')
